





























































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { ZxEditor } from 'zx-editor';
import {
  Button,
  Dialog,
  Toast,
  Popup,
  Picker,
  Checkbox,
  CheckboxGroup,
  Icon,
} from 'vant';
import { save } from '@/api/api';
import { isWeiXin } from '@/common/ts/common';
import * as config from './config';
import { appShare, wxShareInfo } from '@/common/ts/common';
import { initPublish, userHelper, init } from './api/index';
import * as mutationTypes from './store/mutation-types';
import { namespace, State } from 'vuex-class';

const Modules = namespace('CDWM20200317');
type columnKey = 'grade' | 'group' | 'classNumber' | 'category';
interface IPickerItem {
  text: string;
  value?: number;
}
interface IAllPickerData {
  grade: IPickerItem[][];
  group: IPickerItem[];
  classNumber: string[];
  category: IPickerItem[];
}
const pickerGroup = [
  { text: '小学组', value: 1 },
  { text: '中学组', value: 2 },
  { text: '大学组', value: 3 },
  { text: '其他', value: 4 },
];
const pickerGrade = [
  [
    {
      text: '一年级',
      value: 1,
    },
    {
      text: '二年级',
      value: 2,
    },
    {
      text: '三年级',
      value: 3,
    },
    {
      text: '四年级',
      value: 4,
    },
    {
      text: '五年级',
      value: 5,
    },
    {
      text: '六年级',
      value: 6,
    },
  ],
  [
    {
      text: '初一',
      value: 7,
    },
    {
      text: '初二',
      value: 8,
    },
    {
      text: '初三',
      value: 9,
    },
    {
      text: '高一',
      value: 10,
    },
    {
      text: '高二',
      value: 11,
    },
    {
      text: '高三',
      value: 12,
    },
  ],
  [
    {
      text: '大一',
      value: 13,
    },
    {
      text: '大二',
      value: 14,
    },
    {
      text: '大三',
      value: 15,
    },
    {
      text: '大四',
      value: 16,
    },
  ],
  [
    {
      text: '其他',
      value: 17,
    },
  ],
];
Vue.use(Toast)
  .use(Popup)
  .use(Picker)
  .use(Dialog)
  .use(Button)
  .use(CheckboxGroup)
  .use(Checkbox)
  .use(Icon);

function genClassNumber(classNumberLength: number) {
  const arr: any[] = [];
  const base = Array.from(new Array(classNumberLength));

  base.forEach((item, index) => {
    const classNumber = index + 1;
    const el =
      classNumber < 10 ? `0${classNumber.toString()}` : classNumber.toString();
    arr.push(el);
  });
  return arr;
}
@Component({
  name: 'CDWMContribute',
  components: {},
})
export default class Contribute extends Vue {
  options = config.OPTHINES;
  zxEditorPost: any = null;
  name = '';
  title = '';
  teacher = '';
  selectedSchoolVal = -1;
  selectedGroup = '选择阶段';
  selectedGroupVal = -1;
  selectedGrade = '选择年级';
  selectedGradeVal = -1;
  selectedClassNumber = '01';
  showPicker = false;
  showGroupPicker = false;
  pointOut = false;
  noButton = true;
  activeColumnKey: columnKey = 'group';
  buttonShow = true;

  category: any = null; // 原始分类数据，不做任何更改
  cateGroupSeq = 0;
  activeCateGroupIndex: number = 0;
  cateGroup: any[] = [];

  @Modules.State('chooseSchool') selectedSchool!: {};
  @Modules.Mutation(mutationTypes.SAVE_SCHOOL_DATA) saveSchoolData!: (
    schooldata: any,
  ) => void;
  @Watch('selectedGroupVal')
  onGroupChange(newVal: any) {
    if (newVal !== 4) {
      this.buttonShow = true;
      this.saveSchoolData({
        text: '请选择学校',
        value: -1,
      });
      this.selectedGradeVal = -1;
      this.selectedClassNumber = '01';
    }
  }
  get columnData() {
    const allData: IAllPickerData = {
      group: pickerGroup,
      grade: pickerGrade,
      classNumber: genClassNumber(50),
      category: this.category,
    };
    let result = [];
    if (this.activeColumnKey === 'grade') {
      result = allData.grade[this.selectedGroupVal - 1];
    } else {
      result = allData[this.activeColumnKey];
    }
    // 如果选择年级，还需分别返回小学六个年级，和初一~高三两个数组
    return result;
  }

  mounted() {
    // 初始化作文和评论富文本编辑器
    this.zxEditorPost = new ZxEditor('#editorContainerPost', {
      placeholder: '请输入内容',
      showToolbar: false,
      autoSave: 0,
    });
    // 调教编辑器样式
    setTimeout(() => {
      const editorContainerPost = document.querySelector(
        '#editorContainerPost .zxeditor-content-wrapper',
      ) as HTMLElement;
      editorContainerPost.style.cssText = `
      padding: 0 0.6rem; height: 12rem; border: 1px dashed #eee`;
    }, 20);
  }
  created() {
    // 登录成功后回调
    window.userInfoChange = () => {
      this.$router.go(0);
    };
    // 分享
    appShare({
      title: '吃得文明公益主题征文大赛',
      url: window.location.href,
      subtitle:
        '文明健康、绿色环保的生活方式让我们远离病毒，与自然和谐相处，关系大家一生的幸福。',
      classId: -1,
      id: -1,
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    wxShareInfo({
      title: '吃得文明公益主题征文大赛',
      subtitle:
        '文明健康、绿色环保的生活方式让我们远离病毒，与自然和谐相处，关系大家一生的幸福。',
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
    // if (!window.udid) {
    if (isWeiXin()) {
      Dialog.confirm({
        title: '友情提示',
        message: '请在上游新闻App进行上传作品',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        // closeOnClickOverlay: false,
      })
        .then(() => {
          window.location.href =
            'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
        })
        .catch(() => {
          if (isWeiXin() === true) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
    } else {
      if (window.gettoken() === '' || window.gettoken() === 'null') {
        if (parseFloat(window.version) >= 4.5) {
          window.handleMessage('{"action":"mUserLogin","data":""}');
        } else {
          window.location.href = 'client:logout';
        }
      }
    }
    init().then((res) => this.getPublishData(res));
    userHelper().then((res) => console.log('访问userHelper'));
  }
  // 打开对应的picker
  togglePicker(columnKey: any, index = -1) {
    // 检查picker可用性
    if (columnKey === 'grade' && this.selectedGroupVal === -1) {
      return Toast('请选择阶段');
    }
    if (columnKey === 'group' || columnKey === 'category') {
      console.log('是否进入group的选择');
      this.showGroupPicker = true;
    } else {
      this.showPicker = true;
    }
    this.activeColumnKey = columnKey;
    if (columnKey === 'category' && index > -1) {
      this.activeCateGroupIndex = index;
    }
  }
  getPublishData(res: any) {
    console.log('getPublishDatares', res.data);
    const category: any[] = res.data.category;
    this.category = category.map((item: any) => ({
      text: item.name,
      value: item.id,
      ...item,
    }));
    this.cateGroup = [
      {
        active: true,
        data: {
          cateFirst: {
            text: '请选择一级分类',
            value: -1,
          },
          cateSecond: [],
        },
        result: [],
      },
    ];
  }
  // 增加分类
  addCate() {
    if (this.cateGroupSeq < 3) {
      this.cateGroupSeq++;
      this.cateGroup.push({
        active: true,
        data: {
          cateFirst: {
            text: '请选择一级分类',
            value: -1,
          },
          cateSecond: [],
        },
        result: [],
      });
    }
  }
  // 删除分类
  removeCate(cateSelectIndex: number) {
    this.cateGroupSeq--;
    if (this.cateGroup[cateSelectIndex].data.cateFirst.value !== -1) {
      // 将还原项插入数据头部(没法记录原索引)
      this.category.unshift(this.cateGroup[cateSelectIndex].data.cateFirst);
    }
    this.cateGroup.splice(cateSelectIndex, 1);
  }
  // 处理表单确认时的逻辑
  onConfirm(item: IPickerItem, index: number) {
    // 处理年级组显示逻辑
    if (this.activeColumnKey === 'group') {
      this.selectedGroupVal = item.value || -1;
      this.selectedGroup = item.text;
      // 重置选择的年级
      this.selectedGrade = '选择年级';
      this.selectedGradeVal = -1;
      if (this.selectedGroupVal === 4) {
        this.buttonShow = false;
        this.selectedGradeVal = 999;
        this.selectedClassNumber = '999';
        this.saveSchoolData({
          text: '无学校',
          value: 0,
        });
      }
    } else if (this.activeColumnKey === 'grade') {
      this.selectedGradeVal = item.value || -1;
      this.selectedGrade = item.text;
    } else if (this.activeColumnKey === 'classNumber') {
      this.selectedClassNumber = item as any;
    } else if (this.activeColumnKey === 'category') {
      console.log(item.text, this.activeCateGroupIndex, index);
      // 务必在删除之前先存入子分类数据
      this.cateGroup[this.activeCateGroupIndex].data.cateSecond =
        this.category[index].sonCate || [];
      // 删除category中的所选项
      this.category.splice(index, 1);
      // 将还原项插入数据头部(没法记录原索引)
      if (
        item.value !==
          this.cateGroup[this.activeCateGroupIndex].data.cateFirst.value &&
        this.cateGroup[this.activeCateGroupIndex].data.cateFirst.value !== -1
      ) {
        console.log(
          '插入',
          this.cateGroup[this.activeCateGroupIndex].data.cateFirst,
        );
        this.category.unshift(
          this.cateGroup[this.activeCateGroupIndex].data.cateFirst,
        );
      }
      this.cateGroup[this.activeCateGroupIndex].data.cateFirst = item;
      this.cateGroup[this.activeCateGroupIndex].result = [];
    }
    // this.togglePicker();
    this.showGroupPicker = false;
    this.showPicker = false;
  }
  onCancel() {
    this.showGroupPicker = false;
    this.showPicker = false;
  }
  jumpToSchoolList() {
    if (this.buttonShow) {
      this.$router.push({
        path: './SearchSchoolList',
      });
    }
  }

  checkForm() {
    const mobileReg = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
    if (!this.name) {
      Toast('请输入学生姓名');
      return false;
    } else if ((this.selectedSchool as any).value === -1) {
      Toast('请选择学校');
      return false;
    } else if (this.selectedGroupVal === -1) {
      Toast('请选择学段');
      return false;
    } else if (this.selectedGradeVal === -1) {
      Toast('请选择年级');
      return false;
    } else if (!this.selectedClassNumber) {
      Toast('请输入班级');
      return false;
    } else if (this.cateGroup[0].data.cateFirst.value === -1) {
      Toast('请至少选择一个分类');
      return false;
    } else if (!this.title) {
      Toast('请输入作文标题');
      return false;
    } else if (this.zxEditorPost.getContent(true).length <= 1) {
      Toast('作文正文不能为空');
      return false;
    } else {
      return true;
    }
  }
  async submit() {
    if (isWeiXin()) {
      Dialog.confirm({
        title: '友情提示',
        message: '请在上游新闻App进行上传作品',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        // closeOnClickOverlay: false,
      })
        .then(() => {
          window.location.href =
            'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
        })
        .catch(() => {
          if (isWeiXin() === true) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
    }
    // 验证表单完整性
    if (window.gettoken() !== '' && window.gettoken() !== 'null') {
      if (!this.checkForm()) {
        return;
      } else {
        // 重组分类数据适配接口
        // DONE 分类需要数据等待重新组合
        const cateResultFirst: any[] = [];
        let cateResultSecond: any[] = [];
        for (const cateItem of this.cateGroup) {
          if (cateItem.data.cateFirst.value !== -1) {
            cateResultFirst.push(cateItem.data.cateFirst.value);
            cateResultSecond = [...cateResultSecond, ...cateItem.result];
          }
        }
        console.log(
          'submit',
          this.name,
          (this.selectedSchool as any).text,
          this.selectedGroupVal,
          this.selectedGradeVal,
          this.selectedClassNumber,
          cateResultFirst.join(),
          cateResultSecond.join(),
          this.title,
          this.teacher,
          this.zxEditorPost.getContent(),
        );
        save(this.options.voteName, {
          udid: window.udid,
          appkey: window.appkey,
          name: this.name,
          school: (this.selectedSchool as any).text,
          period: this.selectedGroupVal,
          grade: this.selectedGradeVal,
          class: this.selectedClassNumber,
          category_first: cateResultFirst.join(),
          category_second: cateResultSecond.join(),
          title: this.title,
          teacher: this.teacher,
          content: this.zxEditorPost.getContent(),
        }).then((res: any) => this.successSave(res));

        setTimeout(() => {
          this.zxEditorPost.stopAutoSave();
          this.zxEditorPost.removeSave();
          this.zxEditorPost.setContent('');
        }, 1000);
      }
    } else {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
    }
  }
  successSave(res: any) {
    if (res.code === 100) {
      Toast.fail('请登录后再访问！');
    } else if (res.code === 200) {
      Toast.success('提交成功，请等待审核！');
      this.noButton = false;
      setTimeout(() => {
        this.$router.push({ path: './User' });
      }, 3000);
    } else if (res.code === 203) {
      Toast.fail('请登录后再访问！');
    } else {
      Toast('未知错误请联系后台');
    }
  }
}
